import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'pt', flag: '🇧🇷', label: 'Português' },
  { code: 'en', flag: '🇺🇸', label: 'English' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`text-xl hover:scale-110 transition-all duration-200 px-1 pb-1 ${
            i18n.language === lang.code || i18n.language.startsWith(lang.code)
              ? 'border-b-2 border-logo-brown opacity-100' 
              : 'opacity-60 hover:opacity-100 border-b-2 border-transparent'
          }`}
          title={lang.label}
          aria-label={`Change language to ${lang.label}`}
        >
          {lang.flag}
        </button>
      ))}
    </div>
  );
};
